<template>
  <div>
    <loader style="z-index: 99999999" />
    <div class="login-wrap">
      <div class="login-container">
        <div class="login-main">
          <div class="login-form" style="padding: 2rem 0">
            <img class="logo-icon" :class="{ spinning: logoSpinning }" src="/static/images/logo.png">
            <h2 class="subtitle">CRM</h2>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Loader from '@/components/actions/Loader'

export default {
  components: {
    Loader
  },
  data () {
    return {
      logoSpinning: false
    }
  },
  /*
  components: {
    config
  },
  */
  methods: {
    displayDownloadOptions () {
      return !this.isElectron()
    },
    isElectron () {
      return window.isElectron()
    },
    rootApi () {
      return process.env.ROOT_API
    },
    nodeEnv () {
      return process.env.NODE_ENV
    }

    /*
    downloadElectronClient () {
      this.$axios({
        url: 'http://localhost:5000/static/example.pdf',
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.pdf')
        document.body.appendChild(link)
        link.click()
      })
    }
    */
  },

  mounted () {
    this.logoSpinning = false
    setTimeout(() => {
      this.logoSpinning = true
    }, 10)
  }
}
</script>

<style lang="scss">
  body {
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/LoginLayout.vue